import "./assets/scss/styles.scss"; // styles.scss ou styles-prod.scss

import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./i18n";
const currentLang = document.querySelector("html").getAttribute("lang");

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App />);
